export enum NumberFormat {
	DOT_THOUSAND_COMMA_DECIMAL = 'dot-thousand-comma-decimal',
	COMMA_THOUSAND_DOT_DECIMAL = 'comma-thousand-dot-decimal',
	SPACE_THOUSAND_DOT_DECIMAL = 'space-thousand-dot-decimal',
	APOSTROPHE_THOUSAND_DOT_DECIMAL = 'apostrophe-thousand-dot-decimal',
	COMMA_SPACE_THOUSAND_DOT_DECIMAL = 'comma-space-thousand-dot-decimal',
}
